import { gql } from "@apollo/client";

const UPLOAD_STUDENT_AVATAR = gql`
  mutation UploadAvatar($input: UploadStudentAvatarInput!) {
    uploadStudentAvatar(input: $input) {
      me {
        image
      }
    }
  }
`;

export default UPLOAD_STUDENT_AVATAR;
